module.exports = __webpack_public_path__ + "img/36-min.a63d6713.jpg";